export enum DUMMY_PORTAL_MESSAGE_EVENT_TYPE {
  GET_PORTAL_CONFIG = 'EPILOT/GET_PARENT_PORTAL_CONFIG',
  PORTAL_CONFIG_UPDATE = 'EPILOT/PORTAL_CONFIG_UPDATE',
  GET_PORTAL_DESIGN = 'EPILOT/GET_PORTAL_DESIGN',
  PORTAL_DESIGN_RECEIVED = 'EPILOT/PORTAL_DESIGN_RECEIVED',
  PORTAL_CONFIG_RECEIVED = 'EPILOT/PORTAL_CONFIG_RECEIVED',
  PORTAL_DESIGN_UPDATE = 'EPILOT/PORTAL_DESIGN_UPDATE',
  PORTAL_PAGE_UPDATE = 'EPILOT/PORTAL_PAGE_UPDATE',
  HYDRATE_PORTAL_PAGE_INFO = 'EPILOT/HYDRATE_PORTAL_PAGE_INFO',
  DUMMY_MOCK_UPDATE = 'EPILOT/PORTAL_DUMMY_MOCK_UPDATE'
}
